import { IBaseTextBoxEditorProps, BaseTextBoxEditor } from "./BaseTextBoxEditor";

import { IDateTextBoxSpecificProps, DateTextBox } from "./DateTextBox";

import * as React from "react";

export interface IDateTextBoxEditorProps
    extends IBaseTextBoxEditorProps,
    IDateTextBoxSpecificProps,
    React.Props<DateTextBoxEditor> {
    width: string;
}

export class DateTextBoxEditor extends BaseTextBoxEditor<IDateTextBoxEditorProps> {
    private _textBoxRef: DateTextBox;

    constructor(props: IDateTextBoxEditorProps) {
        super(props);
    }

    protected getInput(): JSX.Element {
        const widthStyle = this.props.width ? { width: this.props.width } : { width: '165px' };
        return (
            <div className={`controls-text ${this.props.width ? this.props.width : ""}`} style={widthStyle}>
                <DateTextBox
                    {...(this.props as any)}
                    ref={(ref: DateTextBox) => (this._textBoxRef = ref)}
                    id={this.state.inputGroupId}
                    onValidationResultChange={(isValid: boolean, errors: string[], showValidationMessages: boolean) =>
                        this.handleValidationResultChange(isValid, errors, showValidationMessages)
                    }
                    ariaDescribedby={
                        this._errorMessageId +
                        " " +
                        this._infoTextId +
                        (this.props.ariaDescribedby ? " " + this.props.ariaDescribedby : "")
                    }
                    ariaInvalidCanBeShown={this.state.typingFinished}
                    ariaInvalidShouldBeShown={!this.state.isValidOutside}
                />
                <span className="datepicker-icon" aria-hidden={true} title="Date selector"/>
            </div>
        );
    }

    private handleValidationResultChange(isValid: boolean, errors: string[], showValidationMessages: boolean): void {
        this.onValidationResultChange(isValid, errors, showValidationMessages);

        if (this.props.onValidation) {
            this.props.onValidation(errors);
        }
    }

    public completelyRecalculateValidation(): boolean {
        return this._textBoxRef.completelyRecalculateValidation();
    }

    public isDisabled(): boolean {
        return this.props.disabled || (this._textBoxRef && this._textBoxRef.isDisabled());
    }
}
